// extracted by mini-css-extract-plugin
module.exports = {"main":"Standarts1_main__1bWVG","container":"Standarts1_container__2jCyI"};